import classNames from "classnames";
import { CarouselProvider, DotGroup } from "pure-react-carousel";
import React from "react";
import { lookupColourString } from "../../lookups";
import { RenderDots } from "./SlideshowDots";
import { SlideshowInside } from "./SlideshowInside";

export const Slideshow: React.FC<{
  collection: Queries.CollectionFragment;
}> = ({ collection }) => {
  const { backgroundColour } = collection;
  const background = backgroundColour ?? "Cotton";
  const bgClassName = lookupColourString(background, "bg");
  const textColourClassName = lookupColourString(background, "textForBg");

  const contents = collection.contents.filter(
    (cb) => cb.__typename === "GraphCMS_ContentBlock",
  ) as Array<Queries.ContentBlockFragment>;
  const slidesCount = contents.length;

  return (
    <section
      data-component="Slideshow"
      className={classNames(
        "py-section relative pb-0 lg:pt-48px",
        bgClassName,
        textColourClassName,
      )}
    >
      <div className={classNames("page-grid max-width relative")}>
        <CarouselProvider
          className="page-grid col-span-full col-start-1"
          visibleSlides={1}
          naturalSlideWidth={1}
          naturalSlideHeight={1}
          isIntrinsicHeight={true}
          totalSlides={slidesCount}
        >
          <SlideshowInside slides={contents} />
          <DotGroup
            className="col-span-full col-start-1 row-start-2 space-x-20px self-center justify-self-center"
            renderDots={RenderDots}
          />
        </CarouselProvider>
      </div>
    </section>
  );
};
